import { createContext } from "react";

export const DataInContext = createContext(null)